import React, { Component } from 'react';
import autobind from 'react-autobind';
import { Icon, Button, Popover } from 'antd';
import translate from 'app/translations';

export default class ConfirmApproveSteps extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  render() {
    const toolTipContent = (
      <div style={{ maxWidth: 600 }}>
        <ul>
          <li>{this.t('ConfirmApprove.stepList.settings')}</li>
          <li>{this.t('ConfirmApprove.stepList.permission')}</li>
          <li>{this.t('ConfirmApprove.stepList.hud')}</li>
          <li>{this.t('ConfirmApprove.stepList.recruit')}</li>
        </ul>
      </div>
    );

    return (
      <Popover
        content={toolTipContent}
        title={this.t('ConfirmApprove.subHeading')}
        trigger="click"
      >
        <Button size="small" className="btn-link ant-active-blue">
          <span> {this.t('ConfirmApprove.toolTip')}</span>
          <Icon
            style={{ padding: 0, margin: '0 0 0 2px' }}
            type="info-circle"
          />
        </Button>
      </Popover>
    );
  }
}

